import { render, staticRenderFns } from "./InputWithLabel.vue?vue&type=template&id=2b60ddb1&scoped=true"
import script from "./InputWithLabel.vue?vue&type=script&lang=js"
export * from "./InputWithLabel.vue?vue&type=script&lang=js"
import style0 from "./InputWithLabel.vue?vue&type=style&index=0&id=2b60ddb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b60ddb1",
  null
  
)

export default component.exports